import { atom } from 'jotai'

export interface DeleteComment {
  comment_id: string
  reply_id?: string
  delete: (comment_id: string, reply_id?: string) => void
}

export const rwDeleteDialogAtom = atom<DeleteComment | null>(null)
